<template>
  <div>
    <el-table
      :data="asset_label_list.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      @sort-change="sort"
      stripe
      v-loading="loading"
    >
      <el-table-column label="Label Name" prop="name" sortable="custom"></el-table-column>
      <el-table-column label="Email">
        <template slot-scope="props">
          <p v-for="owner in props.row.owners" :key="owner.id">
            {{owner.email}}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Asset Label Owner">
        <template slot-scope="props">
          <p v-for="owner in props.row.owners" :key="owner.id">
            {{owner.name}}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Client Asset Labels">
        <template slot-scope="props">
          <p v-for="label in props.row.client_asset_labels" :key="label.id">
            {{label.asset_label.name}} (Assets: {{label.assetCount}})
          </p>
        </template>
      </el-table-column>
      <el-table-column label="YT Studio">
        <template slot-scope="props">
          <el-tag type="success" v-if="props.row.on_youtube">Yes</el-tag>
          <el-tag type="danger" v-else>No</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Synced at" sortable="custom">
        <template slot-scope="props">
          <span v-if="props.row.synced_at !== null">{{props.row.synced_at |datetime}}</span>
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props" v-if="props.row.owners === undefined || !props.row.owners.length">
          <el-tooltip content="Edit" placement="top">
            <el-button
                type="warning"
                circle
                size="small"
                icon="el-icon-edit"
                @click="openEdit(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        class="float-right"
        background
        @current-change="currentChange"
        :current-page.sync="asset_label_list.current_page"
        :page-size="100"
        layout="total, prev, pager, next, jumper"
        :total="asset_label_list.total"
    ></el-pagination>
    <AssetLabelDialog />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeUsers', [
      'asset_label_list',
      'stats',
      'loading',
      'order_column',
      'order_type',
      'page_size'
    ])
  },

  methods: {
    ...mapMutations('youtubeUsers', ['setPage', "setAssetLabelDialog", "setSelectedAssetLabel", "setOrdering"]),
    ...mapActions('youtubeUsers', ['listAssetLabels', 'assetLabelsStats']),

    openEdit(asset_label) {
      this.setAssetLabelDialog(true)
      this.setSelectedAssetLabel(asset_label)
    },
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.listAssetLabels()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.listAssetLabels()
    },
  },

  created() {
    this.listAssetLabels()
    this.assetLabelsStats()
  }
}
</script>
